var map = {
	"./404-error.jpg": 1451,
	"./505error.jpg": 22506,
	"./Polygon.svg": 11252,
	"./Right-img.png": 35974,
	"./Rosebg.png": 82448,
	"./Speech Bubble.png": 18942,
	"./about-img.jpg": 14667,
	"./activity-1.jpg": 48881,
	"./activity-2.jpg": 21126,
	"./activity-3.jpg": 80611,
	"./activity-4.jpg": 87984,
	"./activity-5.jpg": 56557,
	"./activity-6.jpg": 94274,
	"./activity-7.jpg": 2335,
	"./ads-1.png": 7542,
	"./ads-2.png": 21517,
	"./ads-banner.png": 83781,
	"./ads-bg-1.png": 55804,
	"./ads-bg-2.png": 44535,
	"./ads-left-banner.png": 74913,
	"./amex-pay.svg": 6590,
	"./amsterdam.jpg": 81998,
	"./apple-pay.svg": 25943,
	"./apple-phone.jpg": 82281,
	"./apple.svg": 99362,
	"./arrow-banner.png": 90738,
	"./balloon-img.png": 70197,
	"./banner-01.png": 16360,
	"./banner-02.png": 78339,
	"./banner-arrow.png": 46154,
	"./banner-btm-img.png": 15444,
	"./banner-btm-shape.png": 98834,
	"./banner-center-bg.png": 23244,
	"./banner-left-bottom-shadow.png": 71675,
	"./banner-left-bottom.png": 26288,
	"./banner-middle.png": 90690,
	"./banner-right-bottom-shadow.png": 18226,
	"./banner-right-bottom.png": 17119,
	"./banner-top-bg.png": 29318,
	"./banner.png": 80758,
	"./banner/aboutbanner.jpg": 74938,
	"./banner/banner-05.png": 54837,
	"./banner/banner-img-04.png": 99602,
	"./banner/banner-img-1.png": 15957,
	"./banner/banner-img-2.png": 13854,
	"./banner/banner-img-3.png": 1543,
	"./banner/banner-img-4.png": 10024,
	"./banner/circle-11.png": 36316,
	"./banner/contactbanner.jpg": 85757,
	"./banner/main-banner-7.png": 86925,
	"./bannerbg.png": 7227,
	"./bannerellipse.png": 70658,
	"./bannerimg.png": 41089,
	"./become-dealer-bg.png": 59937,
	"./bg-left-1.png": 60057,
	"./bg-right-1.png": 94558,
	"./bg/active-img.png": 12894,
	"./bg/agent-bg.png": 91139,
	"./bg/appointment-bg-01.png": 65295,
	"./bg/appointment-bg.png": 1315,
	"./bg/balloon-img.png": 36843,
	"./bg/banner-bg-04.png": 72513,
	"./bg/banner-bg.png": 30954,
	"./bg/banner-bottom-bg.png": 95908,
	"./bg/banner-left-bg.png": 90838,
	"./bg/banner-right-bg.png": 29425,
	"./bg/banner-six-bg-1.png": 12781,
	"./bg/banner-six-bg-2.png": 98806,
	"./bg/become-agent-bg.png": 18893,
	"./bg/bg-01.png": 82763,
	"./bg/business-bg.png": 56698,
	"./bg/cate-bg.png": 84475,
	"./bg/category-bg-05.png": 53890,
	"./bg/category-bg.png": 4840,
	"./bg/celebrate-bg.png": 95083,
	"./bg/celebrate-img.png": 15889,
	"./bg/celebrate.png": 57355,
	"./bg/celebration-bg-01.png": 13028,
	"./bg/celebration-bg.png": 12018,
	"./bg/cloud-01.png": 20343,
	"./bg/cloud-02.png": 31612,
	"./bg/counter-bg.png": 54034,
	"./bg/couple-01.png": 71388,
	"./bg/couple-02.png": 72023,
	"./bg/couple-03.png": 29006,
	"./bg/feature-bg.png": 25976,
	"./bg/footer-bg.png": 843,
	"./bg/holiday-cabin-slider-img-1.jpg": 5256,
	"./bg/holiday-cabin-slider-img-2.jpg": 39479,
	"./bg/honeycomb-texture-bg-1.png": 11556,
	"./bg/join-us.jpg": 14117,
	"./bg/line-bg.png": 24966,
	"./bg/make-it-easy.jpg": 57197,
	"./bg/map.png": 6098,
	"./bg/package-bg-01.png": 71200,
	"./bg/package-bg-02.png": 68763,
	"./bg/package-bg.png": 18382,
	"./bg/plane.png": 50506,
	"./bg/popular-bg.png": 52387,
	"./bg/portfolio-bg.jpg": 72674,
	"./bg/premium-bg.png": 49951,
	"./bg/recom-bg-01.png": 4098,
	"./bg/recom-bg-02.png": 68633,
	"./bg/search-bg.png": 9324,
	"./bg/service-bg-01.png": 87253,
	"./bg/service-bg-02.png": 1502,
	"./bg/service.png": 35449,
	"./bg/test-bg.png": 14512,
	"./bg/testimonal-bg.png": 66418,
	"./bg/vector-bg-01.png": 91543,
	"./bg/vector-bg-02.png": 83964,
	"./bg/venue-bg.png": 96989,
	"./bg/venue.png": 3041,
	"./bg/wedding-bg.png": 754,
	"./bg/why-us-bg.png": 88917,
	"./blog-1.jpg": 88714,
	"./blog-2.jpg": 80789,
	"./blog-3.jpg": 60120,
	"./blog-4.jpg": 23211,
	"./blog/article-1.jpg": 12917,
	"./blog/article-2.jpg": 86666,
	"./blog/article-3.jpg": 42503,
	"./blog/blog-1.jpg": 61759,
	"./blog/blog-10.jpg": 82255,
	"./blog/blog-11.jpg": 9874,
	"./blog/blog-12.jpg": 19773,
	"./blog/blog-13.jpg": 68640,
	"./blog/blog-14.jpg": 51475,
	"./blog/blog-15.jpg": 65014,
	"./blog/blog-16.jpg": 35361,
	"./blog/blog-17.jpg": 57316,
	"./blog/blog-18.jpg": 31735,
	"./blog/blog-19.jpg": 67898,
	"./blog/blog-2.jpg": 77424,
	"./blog/blog-3.jpg": 78349,
	"./blog/blog-4.jpg": 96902,
	"./blog/blog-5.jpg": 19075,
	"./blog/blog-6.jpg": 40948,
	"./blog/blog-7.jpg": 38321,
	"./blog/blog-8.jpg": 76266,
	"./blog/blog-9.jpg": 88423,
	"./blog/blog-seven1.jpg": 10896,
	"./blog/blog-seven2.jpg": 95231,
	"./blog/blog-seven3.jpg": 82562,
	"./blog/blog-six-1.png": 8048,
	"./blog/blog-six-2.png": 79339,
	"./blog/blog-six-3.png": 58210,
	"./blog/blogbanner.jpg": 78059,
	"./blog/blogdetailimg-1.jpg": 58431,
	"./blog/blogdetailimg-2.jpg": 91056,
	"./blog/bloglistimg-1.jpg": 37358,
	"./blog/bloglistimg-2.jpg": 52377,
	"./blog/bloglistimg-3.jpg": 8028,
	"./blog/bloglistimg-4.jpg": 62439,
	"./blog/bloglistimg-5.jpg": 50282,
	"./blog/bloglistimg-6.jpg": 90773,
	"./blog/bloglistimg-7.jpg": 29592,
	"./blog/bloglistimg-8.jpg": 93091,
	"./blog/bloglistingimg-1.jpg": 39890,
	"./blog/bloglistingimg-2.jpg": 49789,
	"./blog/bloglistingimg-3.jpg": 94208,
	"./blog/bloglistview-1.jpg": 6816,
	"./blog/bloglistview-2.jpg": 97135,
	"./blog/bloglistview-3.jpg": 20754,
	"./blog/bloglistview-4.jpg": 44353,
	"./blog/news-article-1.jpg": 79495,
	"./blog/news-article-2.jpg": 99512,
	"./blog/news-article-3.jpg": 3829,
	"./blog/property-blog-1.jpg": 87547,
	"./blog/property-blog-2.jpg": 61100,
	"./blog/property-blog-3.jpg": 99145,
	"./blogquote.jpg": 15342,
	"./brand-bg-2.png": 65636,
	"./brand-bg.png": 69773,
	"./breadcrumb-leftbg.png": 83148,
	"./breadcrumbleft-bg.png": 92442,
	"./breadcrumbright-bg.png": 1581,
	"./breifcase.svg": 22186,
	"./business/business-01.jpg": 51433,
	"./business/business-02.jpg": 24702,
	"./business/business-03.jpg": 56187,
	"./business/business-04.jpg": 26184,
	"./business/team-1.jpg": 72558,
	"./business/team-2.jpg": 71225,
	"./business/team-3.jpg": 43228,
	"./business/team-4.jpg": 97639,
	"./business/team-5.jpg": 85482,
	"./call-calling.png": 48703,
	"./call-calling.svg": 15705,
	"./car-img.jpg": 45438,
	"./car-rental-slider-img-2.jpg": 32608,
	"./car-rental-slider-img.jpg": 49277,
	"./car.png": 24288,
	"./cars-class-1.png": 47928,
	"./cars-class-2.png": 22419,
	"./cars-class-3.png": 71658,
	"./cars-class-4.png": 56325,
	"./cars-class-5.png": 38812,
	"./cars-class-6.png": 27543,
	"./cate-bg-1.png": 97591,
	"./cate-bg-2.png": 39484,
	"./categoriesbg.png": 91233,
	"./category-icon.svg": 19120,
	"./category/category-01.jpg": 48453,
	"./category/category-02.jpg": 25850,
	"./category/category-03.jpg": 89687,
	"./category/category-04.jpg": 8492,
	"./category/category-05.jpg": 46537,
	"./celebrate-01.jpg": 10061,
	"./celebrate-img.png": 13927,
	"./celebrate.jpg": 35565,
	"./chat-attachment.jpg": 26466,
	"./chatsearch.svg": 63952,
	"./city/car-location-1.png": 78610,
	"./city/car-location-2.png": 9577,
	"./city/car-location-3.png": 15104,
	"./city/car-location-4.png": 66431,
	"./city/car-location-5.png": 69494,
	"./city/car-location-6.png": 83469,
	"./city/cities-1.jpg": 91953,
	"./city/cities-2.jpg": 64198,
	"./city/cities-3.jpg": 7331,
	"./city/cities-4.jpg": 31056,
	"./city/cities-5.jpg": 83277,
	"./city/cities-6.jpg": 37346,
	"./city/city-01.jpg": 49215,
	"./city/city-02.jpg": 64880,
	"./city/city-03.jpg": 65805,
	"./city/city-04.jpg": 84358,
	"./contactform-img.svg": 27382,
	"./contactleftimg.jpg": 14220,
	"./content-img.png": 7367,
	"./cowork-01.png": 79965,
	"./cowork-02.png": 98758,
	"./cowork-03.png": 37775,
	"./cta-bg.png": 11742,
	"./cta-img.png": 97114,
	"./ctabg.png": 34093,
	"./designation-img1.jpg": 71108,
	"./designation-img2.jpg": 22739,
	"./details-icon.svg": 46754,
	"./earth-icon.png": 78418,
	"./education.jpg": 7104,
	"./ee.jpg": 93354,
	"./electronics.svg": 46931,
	"./eye-icon.png": 20883,
	"./eye.svg": 85297,
	"./facebook.png": 9176,
	"./facebook.svg": 51378,
	"./fanous.png": 1486,
	"./fashion-style.jpg": 54238,
	"./fashion.jpg": 38106,
	"./favicon.png": 90286,
	"./feature.png": 13748,
	"./featured/Feature-1.svg": 22121,
	"./featured/Feature-2.svg": 7034,
	"./featured/Feature-3.svg": 26091,
	"./featured/Feature-4.svg": 63940,
	"./featured/Feature-5.svg": 18661,
	"./featured/Feature-6.svg": 19526,
	"./featured/Feature-7.svg": 7063,
	"./featured/Feature-8.svg": 31584,
	"./featured/Frame 1776.png": 52665,
	"./featured/accessibility.png": 80071,
	"./featured/bathroom.png": 76189,
	"./featured/best-room-img-1.jpg": 58305,
	"./featured/best-room-img-2.jpg": 8694,
	"./featured/best-room-img-3.jpg": 80307,
	"./featured/best-room-img-4.jpg": 40000,
	"./featured/feature-1.jpg": 12207,
	"./featured/feature-2.jpg": 45568,
	"./featured/feature-3.jpg": 54781,
	"./featured/feature-4.jpg": 14262,
	"./featured/feature-5.jpg": 69523,
	"./featured/feature-6.jpg": 85828,
	"./featured/feature-7.jpg": 63873,
	"./featured/feature-8.jpg": 86522,
	"./featured/feature-9.jpg": 57687,
	"./featured/feature-car-1.jpg": 35450,
	"./featured/feature-car-2.jpg": 92677,
	"./featured/feature-car-3.jpg": 65064,
	"./featured/feature-car-4.png": 57571,
	"./featured/feature-text-logo.png": 48697,
	"./featured/food.png": 66987,
	"./featured/outdoor.png": 16563,
	"./featured/property-feature-1.jpg": 50603,
	"./featured/property-feature-2.jpg": 82908,
	"./featured/property-feature-3.jpg": 80281,
	"./featured/room.jpg": 85610,
	"./featured/safe.png": 90608,
	"./featured/services.png": 87879,
	"./flag-01.png": 92208,
	"./flag-02.png": 57611,
	"./foodhabits.jpg": 49993,
	"./footer-bg--.jpg": 57575,
	"./footer-bg-01.jpg": 58697,
	"./footer-bg-01.png": 2865,
	"./footer-bg-1.png": 85691,
	"./footer-bg.png": 28801,
	"./footer-logo-nine.svg": 55714,
	"./footer-six-bg.png": 59692,
	"./footerlogo.png": 84532,
	"./footerlogo.svg": 46838,
	"./gallery/gallery-01.jpg": 97727,
	"./gallery/gallery-02.jpg": 83376,
	"./gallery/gallery-03.jpg": 51949,
	"./gallery/gallery-04.jpg": 16518,
	"./gallery/gallery-05.jpg": 76003,
	"./gallery/gallery-06.jpg": 29940,
	"./gallery/gallery-1.jpg": 61813,
	"./gallery/gallery-2.jpg": 21322,
	"./gallery/gallery-3.jpg": 33479,
	"./gallery/gallery-4.jpg": 79068,
	"./gallery/gallery-5.jpg": 7065,
	"./gallery/gallery1/gallery-1.jpg": 16871,
	"./gallery/gallery1/gallery-10.jpg": 50407,
	"./gallery/gallery1/gallery-11.jpg": 27754,
	"./gallery/gallery1/gallery-12.jpg": 78741,
	"./gallery/gallery1/gallery-2.jpg": 36888,
	"./gallery/gallery1/gallery-3.jpg": 41205,
	"./gallery/gallery1/gallery-4.jpg": 5582,
	"./gallery/gallery1/gallery-5.jpg": 83627,
	"./gallery/gallery1/gallery-6.jpg": 98972,
	"./gallery/gallery1/gallery-7.jpg": 85849,
	"./gallery/gallery1/gallery-8.jpg": 35010,
	"./gallery/gallery1/gallery-9.jpg": 43071,
	"./gallery/gallery2/galleryimage-1.jpg": 25345,
	"./gallery/gallery2/galleryimage-10.jpg": 16125,
	"./gallery/gallery2/galleryimage-12.jpg": 38351,
	"./gallery/gallery2/galleryimage-2.jpg": 49558,
	"./gallery/gallery2/galleryimage-3.jpg": 77971,
	"./gallery/gallery2/galleryimage-4.jpg": 4160,
	"./gallery/gallery2/galleryimage-5.jpg": 55901,
	"./gallery/gallery2/galleryimage-6.jpg": 18098,
	"./gallery/gallery2/galleryimage-7.jpg": 78127,
	"./gallery/gallery2/galleryimage-8.jpg": 86668,
	"./gallery/gallery2/galleryimage-9.jpg": 84457,
	"./gallery/gallery2/gallerypop-1.jpg": 16039,
	"./gallery/gallery2/gallerypop-10.jpg": 86151,
	"./gallery/gallery2/gallerypop-12.jpg": 14485,
	"./gallery/gallery2/gallerypop-2.jpg": 36056,
	"./gallery/gallery2/gallerypop-3.jpg": 40373,
	"./gallery/gallery2/gallerypop-4.jpg": 4750,
	"./gallery/gallery2/gallerypop-5.jpg": 82795,
	"./gallery/gallery2/gallerypop-6.jpg": 14492,
	"./gallery/gallery2/gallerypop-7.jpg": 85017,
	"./gallery/gallery2/gallerypop-8.jpg": 50530,
	"./gallery/gallery2/gallerypop-9.jpg": 42239,
	"./gallery/galleryimg-1.jpg": 13184,
	"./gallery/galleryimg-10.jpg": 81402,
	"./gallery/galleryimg-11.jpg": 49687,
	"./gallery/galleryimg-2.jpg": 79823,
	"./gallery/galleryimg-3.jpg": 19794,
	"./gallery/galleryimg-9.jpg": 14376,
	"./gallery/gallerymedia-1.jpg": 64713,
	"./gallery/gallerymedia-2.jpg": 68766,
	"./gallery/gallerymedia-3.jpg": 70075,
	"./gallery/gallerymedia-4.jpg": 88488,
	"./gallery/gallerymedia-5.jpg": 16101,
	"./gallery/review-1.jpg": 67899,
	"./gallery/review-2.jpg": 41452,
	"./gallery/review-3.jpg": 39241,
	"./gallery/review-4.jpg": 33402,
	"./gallery/top-rent-room-img-1.jpg": 51912,
	"./gallery/top-rent-room-img-2.jpg": 62839,
	"./galleryicon.svg": 13895,
	"./getdirections.svg": 15856,
	"./google.svg": 12595,
	"./gpay.svg": 84501,
	"./heading-logo-small.png": 57252,
	"./heading-logo.png": 48838,
	"./headingbg.png": 95849,
	"./headingbghover.png": 47731,
	"./headingred-bg.png": 36223,
	"./headingspan-bg.png": 71094,
	"./home-01.jpg": 97297,
	"./home-02.jpg": 39526,
	"./home-03.jpg": 78051,
	"./home-04.jpg": 20048,
	"./home-05.jpg": 20973,
	"./home-06.jpg": 8066,
	"./home-07.jpg": 4383,
	"./home-08.jpg": 76636,
	"./home-09.jpg": 20985,
	"./icons/Logomark-1.png": 95453,
	"./icons/Logomark-2.png": 54214,
	"./icons/Logomark-3.png": 93231,
	"./icons/Logomark-4.png": 50384,
	"./icons/Logomark-5.png": 47289,
	"./icons/Logomark-6.png": 82754,
	"./icons/area-icon.svg": 88746,
	"./icons/bath-icon.svg": 8566,
	"./icons/bed-icon.svg": 89842,
	"./icons/bookmark.svg": 76132,
	"./icons/bx-gift.svg": 28608,
	"./icons/bx-map-pin.svg": 84078,
	"./icons/bx-pie-chart.svg": 85243,
	"./icons/bx-planet.svg": 98360,
	"./icons/bx-power-off.svg": 45933,
	"./icons/bx-repost.svg": 9843,
	"./icons/bx-search-alt.svg": 77492,
	"./icons/bx-trophy.svg": 47780,
	"./icons/bx-wrench.svg": 42577,
	"./icons/calender.svg": 10445,
	"./icons/car-icon.svg": 26691,
	"./icons/category-1.svg": 48929,
	"./icons/category-10.svg": 42755,
	"./icons/category-11.svg": 28114,
	"./icons/category-12.svg": 21249,
	"./icons/category-13.svg": 85712,
	"./icons/category-14.svg": 51599,
	"./icons/category-15.svg": 7870,
	"./icons/category-16.svg": 62045,
	"./icons/category-17.svg": 72572,
	"./icons/category-18.svg": 35739,
	"./icons/category-19.svg": 75370,
	"./icons/category-2.svg": 43890,
	"./icons/category-20.svg": 12366,
	"./icons/category-21.svg": 40799,
	"./icons/category-22.svg": 61772,
	"./icons/category-23.svg": 60717,
	"./icons/category-24.svg": 90498,
	"./icons/category-25.svg": 95667,
	"./icons/category-26.svg": 91264,
	"./icons/category-27.svg": 10865,
	"./icons/category-28.svg": 12710,
	"./icons/category-3.svg": 47203,
	"./icons/category-4.svg": 49276,
	"./icons/category-5.svg": 77821,
	"./icons/category-6.svg": 31550,
	"./icons/category-7.svg": 73980,
	"./icons/category-8.svg": 35976,
	"./icons/category-9.svg": 48345,
	"./icons/category-icon-01.svg": 75941,
	"./icons/category-icon-02.svg": 39718,
	"./icons/category-icon-03.svg": 2519,
	"./icons/chat.svg": 74397,
	"./icons/check-circle-1.png": 35742,
	"./icons/check-circle-2.png": 37845,
	"./icons/discover.svg": 97398,
	"./icons/envelop-icon.png": 34886,
	"./icons/fax-icon.png": 62208,
	"./icons/floor-icon.svg": 97247,
	"./icons/guest-icon.svg": 46217,
	"./icons/icons-1.png": 39769,
	"./icons/icons-10.png": 82493,
	"./icons/icons-11.png": 61364,
	"./icons/icons-12.png": 80271,
	"./icons/icons-2.png": 25762,
	"./icons/icons-3.png": 89419,
	"./icons/icons-4.png": 97428,
	"./icons/icons-5.png": 18557,
	"./icons/icons-6.png": 51142,
	"./icons/icons-7.png": 19887,
	"./icons/icons-8.png": 18232,
	"./icons/icons-9.png": 90945,
	"./icons/job-logomark-1.png": 89743,
	"./icons/job-logomark-2.png": 84628,
	"./icons/job-logomark-3.png": 5757,
	"./icons/job-logomark-4.png": 44034,
	"./icons/job-logomark-5.png": 34539,
	"./icons/job-logomark-6.png": 20720,
	"./icons/job-role.png": 37251,
	"./icons/loc-icon.svg": 79871,
	"./icons/location-icon.png": 94892,
	"./icons/logo.svg": 71938,
	"./icons/marker.png": 43563,
	"./icons/marker1.png": 82458,
	"./icons/marker2.png": 3569,
	"./icons/marker3.png": 9704,
	"./icons/marker4.png": 89319,
	"./icons/marker5.png": 36830,
	"./icons/marker6.png": 22581,
	"./icons/marker7.png": 70316,
	"./icons/master-01.svg": 98667,
	"./icons/phone-icon.png": 68139,
	"./icons/property.svg": 67820,
	"./icons/rating.svg": 14244,
	"./icons/search-icon.svg": 4923,
	"./icons/service-1.svg": 37134,
	"./icons/service-2.svg": 66253,
	"./icons/service-3.svg": 86540,
	"./icons/service-4.svg": 70579,
	"./icons/service-5.svg": 7938,
	"./icons/service-6.svg": 62481,
	"./icons/stripe.svg": 16520,
	"./icons/timeline-01.svg": 29438,
	"./icons/timeline-02.svg": 57885,
	"./icons/timeline-03.svg": 29340,
	"./icons/timeline-04.svg": 56995,
	"./icons/timeline-05.svg": 23954,
	"./icons/timeline-06.svg": 89345,
	"./icons/timeline-07.svg": 90896,
	"./icons/title.svg": 83799,
	"./icons/trip-icon-01.svg": 40784,
	"./icons/trip-icon-02.svg": 46531,
	"./icons/trip-icon-03.svg": 43218,
	"./icons/trip-icon-04.svg": 77149,
	"./icons/trip-icon-05.svg": 48604,
	"./icons/trip-icon-06.svg": 50927,
	"./icons/trip-icon-07.svg": 14526,
	"./icons/trip-icon-08.svg": 31321,
	"./icons/trip-icon-09.svg": 18952,
	"./icons/trip-icon-10.svg": 71126,
	"./icons/users.svg": 18917,
	"./icons/verified.svg": 61315,
	"./icons/visa-01.svg": 12616,
	"./icons/wed-icon-01.svg": 47195,
	"./icons/wed-icon-02.svg": 65832,
	"./icons/wed-icon-03.svg": 90105,
	"./icons/white-search.svg": 22651,
	"./icons/why-us-1.svg": 16754,
	"./icons/why-us-2.svg": 9889,
	"./icons/why-us-3.svg": 74352,
	"./icons/why-us-4.svg": 40239,
	"./icons/work1.jpg": 17925,
	"./icons/work2.jpg": 95322,
	"./icons/work3.jpg": 59159,
	"./innerbanner-bg.png": 58622,
	"./job-img.png": 15093,
	"./latest/Restaurant-1.jpg": 78377,
	"./latest/Restaurant-2.jpg": 86878,
	"./latest/Restaurant-3.jpg": 7035,
	"./latest/Restaurant-4.jpg": 2152,
	"./latest/category-img-1.png": 51658,
	"./latest/category-img-2.png": 65889,
	"./latest/category-img-3.png": 44760,
	"./latest/category-img-4.png": 93751,
	"./latest/category-img-5.png": 48174,
	"./latest/category-img-6.png": 18533,
	"./latest/latest-01.jpg": 32719,
	"./latest/latest-02.jpg": 19104,
	"./latest/latest-03.jpg": 70237,
	"./latest/latest-04.jpg": 15478,
	"./latest/latest-restaurant-1.jpg": 93029,
	"./latest/latest-restaurant-2.jpg": 70426,
	"./latest/latest-restaurant-3.jpg": 34263,
	"./latest/latest-restaurant-4.jpg": 53068,
	"./list/listgrid-1.jpg": 53939,
	"./list/listgrid-2.jpg": 53892,
	"./list/listgrid-3.jpg": 31937,
	"./list/listgrid-4.jpg": 20242,
	"./list/listgrid-5.jpg": 96623,
	"./list/listgrid-6.jpg": 13632,
	"./list/listgrid-7.jpg": 39197,
	"./list/listgrid-8.jpg": 11454,
	"./list/tablelist-1.jpg": 23823,
	"./list/tablelist-2.jpg": 10208,
	"./list/tablelist-3.jpg": 61341,
	"./list/tablelist-4.jpg": 90230,
	"./list/tablelist-5.jpg": 76691,
	"./list/tablelist-6.jpg": 98884,
	"./list/tablelist-7.jpg": 76929,
	"./list/tablelist-8.jpg": 9466,
	"./location-icon.svg": 90095,
	"./locations/australia-1.jpg": 61811,
	"./locations/australia.jpg": 5593,
	"./locations/canada-1.jpg": 14535,
	"./locations/canada.jpg": 89893,
	"./locations/china-1.jpg": 56548,
	"./locations/china.jpg": 67062,
	"./locations/france-1.jpg": 11348,
	"./locations/france.jpg": 23910,
	"./locations/london-1.jpg": 75739,
	"./locations/uk-1.jpg": 44929,
	"./locations/uk.jpg": 56047,
	"./locations/usa-1.jpg": 45216,
	"./locations/usa.jpg": 40282,
	"./logo-01.png": 58189,
	"./logo-afreet-w.png": 32577,
	"./logo-new.png": 45256,
	"./logo-white.png": 58409,
	"./logo-white.svg": 64415,
	"./logo.png": 65549,
	"./logo.svg": 67503,
	"./mail-check.png": 1498,
	"./mail-icon.svg": 5951,
	"./main-banner-7.png": 40640,
	"./main-img.jpg": 13281,
	"./master.svg": 88336,
	"./mediaimg-1.jpg": 58103,
	"./mediaimg-2.jpg": 73352,
	"./news-article-bg.png": 11914,
	"./offer-arrow.svg": 46112,
	"./offer-bg.png": 60386,
	"./partners/brand-1.png": 60601,
	"./partners/brand-2.png": 12418,
	"./partners/brand-3.png": 33547,
	"./partners/brand-4.png": 87636,
	"./partners/brand-5.png": 8765,
	"./partners/brand-6.png": 67526,
	"./partners/partners-1.svg": 84133,
	"./partners/partners-2.svg": 61702,
	"./partners/partners-3.svg": 59735,
	"./partners/partners-4.svg": 86904,
	"./partners/partners-5.svg": 74793,
	"./partners/partners-6.svg": 6682,
	"./petanimal.jpg": 46397,
	"./phone.svg": 89070,
	"./phonecall.svg": 16210,
	"./popular-bg-1.png": 24895,
	"./popular-bg-2.png": 70244,
	"./popular-img.png": 85539,
	"./pricebg.png": 56284,
	"./priceplanbg.png": 18133,
	"./pricing-bg.png": 29698,
	"./pricing-main-bg.png": 48277,
	"./pricingcircle.png": 54496,
	"./pricingli-bg.png": 23581,
	"./pricingli-bg.svg": 34135,
	"./pricinglihover-bg.png": 43195,
	"./pricinglihover-bg.svg": 76135,
	"./profile-img.jpg": 77875,
	"./profiles/avatar-01.jpg": 54802,
	"./profiles/avatar-02.jpg": 92605,
	"./profiles/avatar-03.jpg": 24512,
	"./profiles/avatar-04.jpg": 14675,
	"./profiles/avatar-05.jpg": 86262,
	"./profiles/avatar-06.jpg": 62049,
	"./profiles/avatar-07.jpg": 88452,
	"./profiles/avatar-08.jpg": 83607,
	"./profiles/avatar-09.jpg": 31674,
	"./profiles/avatar-10.jpg": 16880,
	"./profiles/avatar-11.jpg": 17805,
	"./profiles/avatar-12.jpg": 88546,
	"./profiles/avatar-13.jpg": 1215,
	"./profiles/avatar-14.jpg": 80404,
	"./profiles/avatar-15.jpg": 77777,
	"./profiles/avatar-16.jpg": 36358,
	"./profiles/avatar-17.jpg": 58531,
	"./profiles/avatar-18.jpg": 95032,
	"./profiles/reviewauthor-2.svg": 23915,
	"./profiles/reviewauthor-3.svg": 18650,
	"./promo-banner-bg.jpg": 57466,
	"./quote-after.png": 13799,
	"./quote-before.png": 79771,
	"./quotes.png": 87623,
	"./recomended-bg-btm.png": 9656,
	"./recommended/destination-01.jpg": 67360,
	"./recommended/destination-02.jpg": 64623,
	"./recommended/destination-03.jpg": 8594,
	"./recommended/destination-04.jpg": 34081,
	"./recommended/gallery-1.jpg": 81586,
	"./recommended/gallery-2.jpg": 91485,
	"./recommended/gallery-3.jpg": 40352,
	"./recommended/gallery-4.jpg": 23187,
	"./recommended/recommand-01.jpg": 18662,
	"./recommended/recommand-02.jpg": 50865,
	"./recommended/recommand-03.jpg": 62708,
	"./recommended/recommand-04.jpg": 57343,
	"./report.svg": 15720,
	"./resetfilter.svg": 41221,
	"./review.png": 7512,
	"./review.svg": 57542,
	"./ring-bg-1.png": 77194,
	"./ring-bg-2.png": 7777,
	"./save.svg": 92173,
	"./search-icon.png": 72092,
	"./search.jpg": 44476,
	"./search.png": 49432,
	"./service-img.png": 45277,
	"./service/category-01.jpg": 44310,
	"./service/category-02.jpg": 14657,
	"./service/category-03.jpg": 36612,
	"./service/category-04.jpg": 61551,
	"./service/category-05.jpg": 89170,
	"./service/category-06.jpg": 99069,
	"./service/category-img.png": 23814,
	"./service/service-01.jpg": 23303,
	"./service/service-02.jpg": 90456,
	"./service/service-03.jpg": 51637,
	"./service/service-04.jpg": 98222,
	"./services-bg.png": 31546,
	"./services/icon-1.png": 800,
	"./services/icon-2.png": 79131,
	"./services/icon-3.png": 64914,
	"./services/icon-4.png": 37421,
	"./share.svg": 52995,
	"./sms-tracking.png": 12031,
	"./sms-tracking.svg": 27789,
	"./space-img.png": 15310,
	"./statistic-icon.svg": 44534,
	"./story.png": 93245,
	"./subscribe-bg.png": 72612,
	"./success-img.png": 44502,
	"./test-bg.png": 80762,
	"./testi-after-img.png": 70048,
	"./testi-bg.png": 12583,
	"./testi-circle.png": 80146,
	"./testi-circle1.png": 46417,
	"./testi-circle2.png": 21754,
	"./testi-circle3.png": 43331,
	"./testi-circle4.png": 13164,
	"./testimonial-1 - Copy.jpg": 37589,
	"./testimonial-1.jpg": 55509,
	"./testimonial-2.jpg": 88170,
	"./testimonial-banner-bg.jpg": 98194,
	"./title-img-white.png": 2166,
	"./title-img.png": 33970,
	"./trip-icon.png": 16483,
	"./us-flag.png": 98825,
	"./venues/venue-01.jpg": 89558,
	"./venues/venue-02.jpg": 79137,
	"./venues/venue-03.jpg": 1092,
	"./visa.svg": 21997,
	"./website.svg": 80205,
	"./whitebg.png": 79440,
	"./work/city-01.jpg": 43509,
	"./work/city-02.jpg": 19370,
	"./work/city-03.jpg": 15175,
	"./work/city-04.jpg": 60764,
	"./work/city-05.jpg": 5113,
	"./work/city-06.jpg": 6446,
	"./work/trending-car-1.jpg": 55992,
	"./work/trending-car-2.jpg": 35975,
	"./work/trending-car-3.jpg": 84586,
	"./work/trending-car-4.jpg": 21305,
	"./work/trending-car-5.jpg": 34428,
	"./work/work-01.jpg": 63055,
	"./work/work-02.jpg": 96416,
	"./work/work-03.jpg": 21981,
	"./work/work-04.jpg": 65110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;